"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Add = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.Add = function (props) {
    return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "24", height: "23", viewBox: "0 0 24 23", fill: props.fill || common_styles_1.black }),
        React.createElement("path", { d: "M12.1914 2.30859V20.6934", stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M3 11.502H21.3848", stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=add.js.map